import { InjectionToken } from '@angular/core';
import { THREAD_TYPE } from '../../general-agent/models/model';

export { THREAD_TYPE };

export const CHAT_TYPE = new InjectionToken<THREAD_TYPE>('CHAT_TYPE');
